import { VeltComments, VeltInlineCommentsSection, useCommentUtils } from '@veltdev/react';
import './CommentsInlinePage.css';

function CommentsInlinePage() {
    let commentElement = useCommentUtils()
    commentElement?.disableTextComments()

    return (
        <>
            <VeltComments />
{/*             <p className='boujeeText'>Inline comments demo</p> */}
            <div className="article-container" id="articleContainer">
                <h2 className='article-header'>Making the internet more collaborative</h2>
                <p className='article-paragraph'>I’m super excited to announce that we had raised a $2.77M seed round to accelerate our mission to make the internet more collaborative. We are backed by Y Combinator, Spider Capital, Amino Capital, First Row Partners and angel investors from Google, Stripe, SAP and more.</p>
                <VeltInlineCommentsSection targetInlineCommentElementId='articleContainer' />
            </div>
        </>
    )
}

export default CommentsInlinePage;
